{
  "registerButton": "Rekisteröidy käyttäjäksi",
  "registrationSucceeded": "Rekisteröityminen onnistui",
  "registrationCancelled": "Rekisteröityminen peruutettu",
  "registrationFailed": "Virhe tunnusten luonnissa.",
  "createNewPassword": "Luo salasana",
  "createNewPasswordDescription": "Tällä salasanalla pääset jatkossa kirjautumaan asukassivuille.",
  "createNewPasswordValidationErrorGeneric": "Salasanan tulee täyttää kaikki vaatimukset",
  "createNewPasswordValidationErrorMatcingPasswords": "Salasanat eivät täsmää",
  "createNewPasswordValidationErrorLength": "Vähintään 8 merkkiä",
  "createNewPasswordValidationErrorNumber": "Numero",
  "createNewPasswordValidationErrorSpecialCharacter": "Erikoismerkki",
  "createNewPasswordValidationErrorUppercase": "Iso kirjain",
  "createNewPasswordValidationErrorLowercase": "Pieni kirjain",
  "createNewPasswordValidationSectionHeader": "Vahva salasana:",
  "createNewPasswordValidationSectionSubheader": "Huomaathan, että ääkkösiä (ä, ö, å) ei voi käyttää.",
  "createNewPasswordValidationErrorScandicLetters": "Ei merkkejä å, ä tai ö",
  "newPasswordLabel": "Salasana",
  "newPasswordAgainLabel": "Salasana uudelleen",
  "confirmEmailHeader": "Vahvista sähköposti",
  "confirmEmailError": "Sähköpostiosoitteen lisääminen ei onnistunut",
  "confirmEmailLabel": "Sähköposti",
  "confirmEmailSubmit": "Vahvista sähköposti",
  "confirmEmailDescription": "Sähköposti toimii käyttäjätunnuksena asukassivuille.",
  "confirmEmailSubmitError": "Sähköpostin vahvistuksessa tapahtui virhe",
  "confirmEmaiCancel": "Peruuta",
  "verificationCodeError": "Koodi on virheellinen tai vanhentunut",
  "verificationCodeSubmit": "Vahvista",
  "verificationCodeLabel": "Vahvistuskoodi",
  "verificationCodeDescription": "Vahvistuskoodi on lähetetty osoitteeseen",
  "verificationCodeResendDescription": "Jos et saanut koodia, odota hetki, tarkista roskapostikansio tai",
  "verificationCodeResendLink": "lähetä koodi uudelleen",
  "verificationCodeResendStatus": "Uusi koodi lähetetty klo {{time}}",
  "verificationCodeResendError": "Vahvistuskoodin lähetyksessä tapahtui virhe",
  "resendVerificationCode": {
    "linkText": "Lähetä vahvistuskoodi uudelleen tästä.",
    "success": "Käyttäjätunnus vahvistettu onnistuneesti. Voit nyt kirjautua sisään tunnuksella ja salasanalla."
  },
  "ftnCallbackErrorMessage": "Virhe tunnusten luonnissa.",
  "ftnCallbackErrorDescription": "Kokeile tehdä rekisteröityminen uudestaan. Vaihda tarvittaessa tunnistautumistapaa.",
  "ftnCallbackErrorBackButtonText": "Takaisin etusivulle",
  "continueRegistrationInfo4": "Jos haluat vaihtaa sähköpostiosoitetta",
  "continueRegistrationInfo3": "Jos et saanut koodia (odota hetki ja tarkista myös roskapostikansio) tai se on ehtinyt vanhentua",
  "continueRegistrationInfo2": "Olet saanut vahvistuskoodin osoitteeseen <strong>{{email}}</strong>.",
  "continueRegistrationInfo1": "Rekisteröitymisesi jäi aiemmin kesken. Sinun tulee vielä vahvistaa sähköpostiosoitteesi.",
  "continueRegistrationHeader": "Tervetuloa takaisin",
  "resetRegistrationLinkText": "aloita rekisteröityminen alusta",
  "chooseAuthHeader": "Rekisteröidy käyttäjäksi",
  "chooseAuthFtn": "Pankkitunnukset tai mobiilivarmenne",
  "chooseAuthPassport": "Passi tai henkilökortti",
  "invitationLoadError": "Kutsun lataaminen ei onnistunut.",
  "invitationExpiredTitle": "Kutsu on vanhentunut",
  "invitationExpiredDescription": "Tämä rekisteröitymiskutsu on vanhentunut. Pyydä uusi kutsu.",
  "invitationAlreadyRegisteredTitle": "Tunnus on jo luotu",
  "invitationAlreadyRegisteredDescription": "Tälle kutsulle on jo luotu käyttäjätunnus. Voit kirjautua sisään.",
  "invitationRegisterError": "Rekisteröityminen ei onnistunut.",
  "invitationCreatePasswordHeader": "Luo salasana",
  "invitationCreatePasswordDescription": "Luot käyttäjätunnuksen sähköpostiosoitteelle {{email}}. Aseta salasana, jolla pääset jatkossa kirjautumaan asukassivuille.",
  "registrationWrongDomain": "Aloita rekisteröityminen osoitteesta: {{url}}."
}
